



































































































































































import Vue, { VueConstructor } from 'vue';
import DatetimePicker from 'vuetify-datetime-picker';
import { AxiosResponse, AxiosError } from 'axios';
import { ToastMessage } from '@/plugins/toast/models/message';
import { ErrorStatesOptions } from '@/models/errorEntities';
import services from '../../services';
import { UserInstallationDateVm, ErrorVm } from './viewModel';
import { User, SupportProperties, SupportType, UserTimeState, Attachment } from '../../models';
import FinishedPageDialog from '@/common/components/FinishedPageDialog.vue';
import { PageTitle } from '@/common/components';
import lang from '../../common/lang/de';
import ProductList from '../../common/utils/product-list';
import { RulesOperatorHelper } from '../../common/utils/RulesOperatorHelper';
import { ConversorBytes } from '../../common/utils/ConversorBytes';
import { checkInstallationDate } from './businessLayout/userTimeState';

Vue.use(DatetimePicker);
const { UserService } = services;

export default (Vue as VueConstructor<Vue & {
  $refs: {
    finishedPageDialog: InstanceType<typeof FinishedPageDialog>,
    form: HTMLFormElement,
    datePicker: InstanceType<typeof DatetimePicker>,
  },
  formValid: boolean,
}>).extend({
  name: 'NewSupportRequest',
  components: {
    FinishedPageDialog,
    PageTitle,
  },
  data() {
    return {
      userCustomerNumber: '' as string,
      userTimeState: {} as UserTimeState,
      userInstallationDateVm: {
        isShowPrioCall: false,
        isShowHeaderText: false,
      } as UserInstallationDateVm,
      prioCallOption: false as boolean,
      subject: '' as string,
      contactPerson: '' as string,
      description: '' as string,
      formValid: true as boolean,
      sendClickedAndFormWasValid: false as boolean,
      errors: [] as ErrorVm[],
      userParams: {} as User,
      isCallCenterUser: false as boolean,
      rules: {
        form: () => this.formValid,
        maxLength: (value) => (value && value.trim().length <= 45) || RulesOperatorHelper.maxLength(45),
        maxLengthRequest: (value) => (value && value.trim().length <= 2000) || RulesOperatorHelper.maxLength(2000),
        required: (value) => (!!value && (value.trim() !== '')) || lang.formRules.required,
      } as any,
      dateToCall: false as boolean,
      dateTime: null as any,
      textFieldProps: {
        appendIcon: 'event',
      },
      dateProps: {
        headerColor: 'primary',
        color: 'primary',
        locale: 'de-De',
        allowedDates: (date: string): boolean => {
          const actualDate = new Date();
          return new Date(date) >= new Date(actualDate.toDateString());
        },
        firstDayOfWeek: 1,
      },
      timeProps: {
        headerColor: 'primary',
        ampmInTitle: true,
        color: 'primary',
        locale: 'de-De',
        format: '24hr'
      },
      productLines: [] as string[],
      products: {
        productLineSelected: '' as string,
        itemSelected: '' as string,
        items: ProductList.items,
        search: '' as string,
      },
      kindOfSupport: {
        values: [] as string[],
        isShowPrioCall: true as boolean,
        showComboSupport: false as boolean,
        supportSelected: '' as string,
      },
      attachments: [] as any[],
      maxSizeFile: 1024 as number,
      sizeFileValid: [] as boolean[],
    };
  },
  mounted() {
    this.userCustomerNumber = this.$route.params.id;
    this.userParams = {
      osaId: this.$store.getters['user/getOsaId'],
      customer: this.$store.getters['user/getDebtorNumber'],
      appId: Number(this.$store.getters['user/getAppId']),
    } as User;
    this.isCallCenterUser = this.$store.getters['user/isCustomer'] === false;
    this.initialize();
    this.loadProduklinienCustomer();
    this.loadKindSupport();
    this.loadMaxSizeAttachment();
    this.productsOrderAsc();
  },
  watch: {
    'products.productLineSelected': function () {
      this.products.itemSelected = '';
      this.products.search = '';
    },
  },
  computed: {
    filteredProductList(): string[] {
      const filteredList = this.products.items[this.products.productLineSelected] || [];
      return filteredList;
    },
    oneProductLine(): boolean {
      return this.productLines.length === 1;
    },
  },
  methods: {
    initialize() {
      this.$loader.show();
      UserService.getInstallationDaysAgo(this.userParams).then(result => {
        this.userTimeState.daysFromInstallationDate = result.data.daysFromInstallationDate;
        this.userTimeState.supportTimeCredit = result.data.supportTimeCredit;
        this.checkUserTimeState();
        setTimeout(() => {
          this.$loader.hide();
        }, 500);
      }).catch((err: AxiosError) => {
        if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    checkUserTimeState(): UserInstallationDateVm {
      if (this.userTimeState.supportTimeCredit) {
        this.userInstallationDateVm = checkInstallationDate(this.userTimeState);
      } else {
        this.userInstallationDateVm.isShowHeaderText = false;
        this.userInstallationDateVm.isShowPrioCall = true;
      }
      return this.userInstallationDateVm;
    },
    defaultDateToCall() {
      if (this.dateToCall) {
        const dateTime = new Date();
        dateTime.setDate(dateTime.getDate() + 1);
        dateTime.setHours(8, 0, 0);
        this.dateTime = dateTime;
      } else {
        this.dateTime = null;
        this.$refs.datePicker.clearHandler();
      }
      return this.dateTime;
    },
    loadKindSupport() {
      this.kindOfSupport.supportSelected = this.$store.getters['user/getSupportSelected'];
      if (this.kindOfSupport.supportSelected === 'GCS') {
        this.kindOfSupport.isShowPrioCall = false;
      }
    },
    setKindSupport(kinfOfSupportValues: string[]) {
      kinfOfSupportValues.forEach(value => {
        value = value + '-Supportanfragen';
      });
      this.kindOfSupport.values = kinfOfSupportValues;
    },
    changeKindSupport() {
      if (this.kindOfSupport.supportSelected.includes('GCS')) {
        this.kindOfSupport.isShowPrioCall = false;
      } else {
        this.kindOfSupport.isShowPrioCall = true;
      }
    },
    loadProduklinienCustomer() {
      UserService.getCustomerProductLine(this.userCustomerNumber).then((result: AxiosResponse<string>) => {
        const produktlinien = result.data;
        if (produktlinien) {
          this.productLines = produktlinien.split(',').map((item: string) => item.trim());
          this.products.productLineSelected = this.productLines[0];
        }
      }).catch((err: AxiosError) => {
        if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.NotAuthorized);
          this.$router.push({ name: 'Index' });
        } else {
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
          this.showError(ErrorStatesOptions.UnexpectedError);
        }
      });
    },
    productsOrderAsc() {
      this.products.items.VCS = this.products.items.VCS.sort();
      this.products.items.NET = this.products.items.NET.sort();
      if (!this.products.items.VCS.includes('Sonstige')) {
        this.products.items.VCS.push('Sonstige');
      }

      const appId = this.$store.getters['user/getAppId'];
      if (appId === '9000') {
        this.products.productLineSelected = 'VCS';
        this.products.itemSelected = 'VxS';
      }
    },
    validProduct() {
      return this.filteredProductList.includes(this.products.itemSelected);
    },
    loadMaxSizeAttachment() {
      UserService.getMaxSizeAttachment()
        .then((result: AxiosResponse<number>) => {
          this.maxSizeFile = result.data;
          setTimeout(() => {
            this.$loader.hide();
          }, 500);
        })
        .catch((err: AxiosError) => {
          if (err.response !== undefined && (err.response.status === 401 || err.response.status === 500)) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push('/');
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
        });
    },
    onPickFile() {
      (this.$refs.fileInput as HTMLElement).click();
    },
    onFilePicked($event: InputEvent) {
      const files = Array.from(($event.target as HTMLInputElement).files);
      if (files.length >= 1) {
        for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
          const file = files[fileIndex];
          this.getAttachmentArray(file);
        }
      }
    },
    isSizeFileValid(sizeFile: number): boolean {
      return !(sizeFile > this.maxSizeFile);
    },
    getAttachmentArray(file: File | Blob): void {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = (fileloadEvent) => {
        const readerResult = fileloadEvent.target.result as string;
        const base64 = readerResult.split(',')[1];
        this.attachments.push({
          file: base64,
          filename: (file as File).name,
          size: ConversorBytes.formatSizeFile(file.size)
        } as Attachment);
        this.sizeFileValid.push(this.isSizeFileValid(ConversorBytes.bytesToKilobytes(file.size)));
      };
    },
    removeImage(attachment: Attachment): void {
      const itemPosition = this.attachments.indexOf(attachment);
      this.sizeFileValid.splice(itemPosition, 1);
      this.attachments.splice(itemPosition, 1);
    },
    getSupportTypeKSR(): number {
      return this.userInstallationDateVm.isShowPrioCall ? (this.prioCallOption ? SupportType.PrioCall : SupportType.Standard) : SupportType.PrioCall;
    },
    goTo() {
      if (this.isCallCenterUser) {
        this.$router.push({
          name: 'SelectedCustomer',
          params: {
            id: this.userCustomerNumber,
          },
        });
      } else {
        this.$router.push({
          name: 'Welcome',
          params: {
            id: this.userParams.osaId as string,
          },
        });
      }
    },
    checkForm(event) {
      this.formValid = true;
      this.errors = [];

      if (!this.$refs.form.validate()) {
        this.formValid = false;
      }
      if (!this.subject) {
        this.errors.push({
          visible: true,
          message: 'Bitte geben Sie einen Betreff an.'
        });
        this.formValid = false;
      }
      if (!this.contactPerson) {
        this.errors.push({
          visible: true,
          message: 'Bitte geben Sie einen Ansprechpartner'
        });
        this.formValid = false;
      }
      if (!this.validProduct()) {
        this.errors.push({
          visible: true,
          message: 'Bitte wählen Sie ein Produkt.'
        });
        this.formValid = false;
      }
      if (!this.description) {
        this.errors.push({
          visible: true,
          message: 'Bitte beschreiben Sie Ihre Anfrage.'
        });
        this.formValid = false;
      }
      if (this.dateToCall) {
        const actualDate = new Date();
        if (this.dateTime < actualDate) {
          this.errors.push({
            visible: true,
            message: 'Bitte geben Sie ein späteres Datum als das aktuelle Datum ein.'
          });
          this.formValid = false;
        }
      }
      if (this.sizeFileValid.includes(false)) {
        this.errors.push({
          visible: true,
          message: 'Der Anhang ist zu groß. Die maximale Größe in Kilo-Bytes ist: ' + this.maxSizeFile
        });
        this.formValid = false;
      }

      event.preventDefault();

      if (this.formValid) {
        this.$loader.show();
        this.sendClickedAndFormWasValid = true;
        const suffixSubject = this.isCallCenterUser ? 'KUCM: ' : 'KUKU: ';
        this.description = this.description.replace(/\n/g, '\r\n');
        const supportParams = {
          osaId: this.userParams.osaId,
          appId: Number(this.userParams.appId),
          callCenterId: this.isCallCenterUser ? this.$store.getters['user/getCustomerNumber'] : null,
          contactPerson: this.contactPerson,
          product: this.products.itemSelected,
          productLine: this.products.productLineSelected,
          caseCallBackNotBefore: this.dateToCall ? this.dateTime : null,
          subject: `${suffixSubject}${this.subject}`,
          message: `Ansprechpartner: ${this.contactPerson}\r\n\r\n${this.description}`,
          supportType: this.kindOfSupport.supportSelected.includes('GCS') ? SupportType.GCS : this.getSupportTypeKSR(),
          debtorNumber: this.isCallCenterUser ? localStorage.getItem('callCenterSelectedCustomerNumber') : this.userParams.customer
        } as SupportProperties;
        UserService.addRequest(supportParams).then(result => {
          let caseRequest;
          let promises: Promise<any>[] = [];

          this.attachments.forEach((attachment: Attachment) => {
            let promise = new Promise((resolve, reject) => {
              caseRequest = Object.assign({}, result.data);
              caseRequest.file = attachment.file;
              caseRequest.filename = attachment.filename;
              UserService.addAttachmentToCase(caseRequest)
                .then(result => {
                  resolve(result);
                })
                .catch((err: AxiosError) => {
                  reject(err);
                });
            });
            promises.push(promise);
          });

          Promise.all(promises)
            .then(() => {
              const { header, body, preFooter, footer } = lang.newSupportRequest.dialog;
              this.$refs.finishedPageDialog.pop(header, body, preFooter, footer).then(response => {
                if (response === true && !this.isCallCenterUser) {
                  this.$router.push({
                    name: 'Welcome',
                    params: {
                      id: this.userParams.osaId as string,
                    },
                  });
                } else {
                  this.$router.push({ name: 'CallCenterIndex' });
                }
              });
              this.$loader.hide();
            })
            .catch(() => {
              this.$loader.hide();
              this.sendClickedAndFormWasValid = false;
              this.showError(ErrorStatesOptions.UnexpectedError);
            });
        }).catch((err: AxiosError) => {
          if ((err.response !== undefined) && (err.response.status === 401 || err.response.status === 500)) {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.NotAuthorized);
            this.$router.push({ name: 'Index' });
          } else {
            setTimeout(() => {
              this.$loader.hide();
            }, 500);
            this.showError(ErrorStatesOptions.UnexpectedError);
          }
          this.sendClickedAndFormWasValid = false;
        });
      }
    },
    showError(error: ErrorStatesOptions) {
      const toast = {} as ToastMessage;
      switch (error) {
        case ErrorStatesOptions.NotAuthorized:
          toast.header = lang.global.error.NotAuthorized.header;
          toast.message = lang.global.error.NotAuthorized.message;
          break;
        case ErrorStatesOptions.UnexpectedError:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
        default:
          toast.header = lang.global.error.unerwarteter.header;
          toast.message = lang.global.error.unerwarteter.message;
          break;
      }
      this.$toast.error(toast);
    },
  },
});
